// Currently any unregistered user token will be stored under a single generic key in
// the cookies (UNREGISTERED_USER_TOKEN_STORAGE_KEY).
// If at some point we need to have multiple unregistered user tokens stored in the
// same machine, we will need to somehow pass them dynamically to the auth config.
export const UNREGISTERED_USER_TOKEN_STORAGE_KEY = 'unregistered-user-token'
